import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalFooter,
    ModalBody,
    ModalCloseButton,
    useDisclosure,
    Input,
    Button,
    FormLabel,
    FormControl,
    IconButton,
    InputGroup,
    InputRightElement,
  } from '@chakra-ui/react';
  import { FaEye, FaEyeSlash } from 'react-icons/fa';
  import React, { useState,useEffect } from 'react';
  import axios from 'axios';
  import { useNavigate } from 'react-router-dom'; // Import useHistory from react-router-dom
  import { useToast } from '@chakra-ui/react'

  function TeacherLogin() {
    const { isOpen, onOpen, onClose } = useDisclosure();
    const [showPassword, setShowPassword] = useState(false);
    const initialRef = React.useRef(null);
    const finalRef = React.useRef(null);
    const navigate = useNavigate(); // Access history object from react-router-dom
    const toast = useToast() 
    const [loading,setLoading]=useState(false)

   

    const handleSubmit = async () => {
        setLoading(true)
      try {
        // Send POST request to the teacher login endpoint
        const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/teacherlogin`, {
          email: initialRef.current.value,
          password: finalRef.current.value,
        });
        const token = response.data.token;
        localStorage.setItem('sbpathshalaAdmin',token);

        toast({
            title: 'Successfully Login',
            description: "",
            status: 'success',
            duration: 9000,
            isClosable: true,
            position: 'bottom-center',
          })
            navigate("/teachers/dashboard")
      } catch (error) {
        toast({
            title: 'Error',
            description: "",
            status: 'error',
            duration: 9000,
            isClosable: true,
            position: 'bottom-center',
          })
        // Handle login error (show error message, etc.)
      }
      setLoading(false)
    };
  
    return (
      <div >
        <Button colorScheme='teal' size='sm' onClick={onOpen}>
          Teacher Login
        </Button>
  
        <Modal
          initialFocusRef={initialRef}
          finalFocusRef={finalRef}
          isOpen={isOpen}
          onClose={onClose}
        >
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>Teacher Login</ModalHeader>
            <ModalCloseButton />
            <ModalBody pb={6}>
              <FormControl>
                <FormLabel>Email</FormLabel>
                <Input ref={initialRef} placeholder='Enter Email' />
              </FormControl>
  
              <FormControl mt={4}>
                <FormLabel>Password</FormLabel>
                <InputGroup>
                  <Input
                    type={showPassword ? 'text' : 'password'}
                    placeholder='Enter Password'
                    ref={finalRef}
                  />
                  <InputRightElement width='3rem'>
                    <IconButton
                      h='1.75rem'
                      size='sm'
                      onClick={() => setShowPassword(!showPassword)}
                      icon={showPassword ? <FaEyeSlash /> : <FaEye />}
                    />
                  </InputRightElement>
                </InputGroup>
              </FormControl>
            </ModalBody>
  
            <ModalFooter>
              <Button colorScheme='blue' mr={3} onClick={handleSubmit} isLoading={loading}>
                Login
              </Button>
              <Button onClick={onClose}>Cancel</Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
      </div>
    );
  }
  
  export default TeacherLogin;
  
  